import conversationModule from '@/store/modules/conversation.module'
import { BUTTON_TYPES } from '@/store/constants'
import { STATE_ID } from '@/utils/bot-json.constants'
import contentUtils from '@/utils/content.utils'
import append from 'ramda/src/append'
import { checkIsString } from '@/utils/preconditions'
import templateModule from '@/store/modules/template.module'
import templateController from '@/controllers/template.controller'
import answerController from '@/controllers/answer.controller'
import randomUtils from '@/utils/random.utils'

class OutputChatBubbleModule {

  addUrlButton(actionWithId, title, payload = '') {
    checkIsString(actionWithId.id, 'actionWithId.id')

    const text = contentUtils.getText(actionWithId)
    const quickReplies = contentUtils.getQuickReplies(actionWithId)
    const buttons = append({
      title,
      type: BUTTON_TYPES.URL,
      payload
    }, contentUtils.getButtons(actionWithId))

    const content = contentUtils.createContent(text, buttons, quickReplies)
    conversationModule.addOutputAction(actionWithId.id, content)
  }

  addActionButton(stateId, actionWithId, title) {
    checkIsString(actionWithId.id, 'actionWithId.id')

    const previewController = templateModule.isTemplateEditor() ? templateController : answerController

    const postback = this._getPostback()
    const text = contentUtils.getText(actionWithId)
    const quickReplies = contentUtils.getQuickReplies(actionWithId)
    const button = {
      title,
      type: BUTTON_TYPES.POSTBACK,
      payload: postback
    }
    const buttons = append(button, contentUtils.getButtons(actionWithId))

    const content = contentUtils.createContent(text, buttons, quickReplies)
    conversationModule.addOutputAction(actionWithId.id, content)
    previewController.addPostback(stateId, postback, STATE_ID.REF_GLOBAL_IDLE, templateModule.getTemplateId())
  }

  // makes testing easier
  _getPostback() {
    return 'postback_' + randomUtils.randomString(5)
  }
}

export default new OutputChatBubbleModule()
